import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import styled from "styled-components";
import { cacheCustomers1, cacheProducts1 } from "../service/cache";
import { useState } from "react";

const ReloadButton = styled(Button)`
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
	height: 32px;
	width: 32px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 4px;
`;

export const ReloadComponent = ({
	setRefreshTrigger
}: {
	setRefreshTrigger?: Function;
}) => {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<ReloadButton
			type="button"
			onClick={async () => {
				const customerToastId: any = toast.warning(
					`Đang tải lại dữ liệu khách hàng, đừng chuyển trang...`,
					{
						autoClose: false
					}
				);

				const productToastId: any = toast.warning(
					`Đang tải lại dữ liệu sản phẩm, đừng chuyển trang...`,
					{
						autoClose: false
					}
				);

				setIsLoading(true);

				await Promise.all([
					cacheCustomers1((progress) => {
						toast.update(customerToastId, {
							render: `Đang tải dữ liệu khách hàng, đừng chuyển trang - ${Math.round(
								progress * 100
							)}%`
						});
					}),

					cacheProducts1((progress) => {
						toast.update(productToastId, {
							render: `Đang tải dữ liệu sản phẩm, đừng chuyển trang - ${Math.round(
								progress * 100
							)}%`
						});
					})
				]);

				setIsLoading(false);
				toast.dismiss();
				if (setRefreshTrigger) {
					setRefreshTrigger((prev: boolean) => !prev);
				}
			}}
			disabled={isLoading}
			title="Refresh dữ liệu"
		>
			🔄
		</ReloadButton>
	);
};
